import { Box } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";

const Activities = () => {
  const { t } = useTranslation();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));

  return (
    <Box>
      <Box
        sx={{
          paddingX: isMobile ? 4 : 24,
          paddingY: isMobile ? 3 : 6,
          backgroundColor: "#f5f5f5",
          borderBottom: "1px solid #eee",
        }}
      >
        <h1
          style={{
            fontSize: "28px",
            color: "#333",
            letterSpacing: "1px",
            textTransform: "uppercase",
            fontWeight: "600",
            margin: 0,
            marginBottom: 5,
          }}
        >
          {t("menu.activities")}
        </h1>
      </Box>

      <Box className="content" sx={{ paddingX: isMobile ? 4 : 24, paddingY: isMobile ? 1 : 3 }}>
        <span style={{ color: "#555", fontWeight: "500", display: "block", marginBottom: "30px" }}>
          {t("activities.title")}
        </span>

        <ul>
          <li style={{ marginBottom: "15px", lineHeight: "1.8", color: "#555" }}>
            {t("activities.vp1")} <br />
            <p>{t("activities.t1.1")}</p>
            <p>{t("activities.t1.2")}</p>
            <p>{t("activities.t1.3")}</p>
            <p>{t("activities.t1.4")}</p>
            <p>{t("activities.t1.5")}</p>
            <p>{t("activities.t1.6")}</p>
            <p>{t("activities.t1.7")}</p>
            <p>{t("activities.t1.8")}</p>
          </li>

          <li style={{ marginBottom: "15px", lineHeight: "1.8", color: "#555" }}>
            {t("activities.vp2")} <br />
            <p>{t("activities.t2.1")}</p>
            <p>{t("activities.t2.2")}</p>
            <p>{t("activities.t2.3")}</p>
            <p>{t("activities.t2.4")}</p>
            <p>{t("activities.t2.5")}</p>
            <p>{t("activities.t2.6")}</p>
            <p>{t("activities.t2.7")}</p>
          </li>

          <li style={{ marginBottom: "15px", lineHeight: "1.8", color: "#555" }}>
            {t("activities.vp3")} <br />
            <p>{t("activities.t3.1")}</p>
            <p>{t("activities.t3.2")}</p>
            <p>{t("activities.t3.3")}</p>
            <p>{t("activities.t3.4")}</p>
            <p>{t("activities.t3.5")}</p>
            <p>{t("activities.t3.6")}</p>
            <p>{t("activities.t3.7")}</p>
          </li>

          <li style={{ marginBottom: "15px", lineHeight: "1.8", color: "#555" }}>
            {t("activities.vp4")} <br />
            <p>{t("activities.t5.1")}</p>
            <p>{t("activities.t4.2")}</p>
            <p>{t("activities.t4.3")}</p>
            <p>{t("activities.t4.4")}</p>
            <p>{t("activities.t4.5")}</p>
          </li>

          <li style={{ marginBottom: "15px", lineHeight: "1.8", color: "#555" }}>
            {t("activities.vp5")} <br />
            <p>{t("activities.t5.1")}</p>
            <p>{t("activities.t5.2")}</p>
            <p>{t("activities.t5.3")}</p>
            <p>{t("activities.t5.4")}</p>
            <p>{t("activities.t5.5")}</p>
          </li>

          <li style={{ marginBottom: "15px", lineHeight: "1.8", color: "#555" }}>
            {t("activities.vp6")} <br />
            <p>{t("activities.t6.1")}</p>
            <p>{t("activities.t6.2")}</p>
            <p>{t("activities.t6.3")}</p>
            <p>{t("activities.t6.4")}</p>
            <p>{t("activities.t6.5")}</p>
          </li>
        </ul>
      </Box>
    </Box>
  );
};

export default Activities;
